import { Entry } from "./entry";

export class ContentBlock {

    id: number;
    content: string;
    location: string;
    order: string;
    title: string;
    entry?: Entry;

    public static createMany(data: any[]): ContentBlock[] {
        let contentBlocks: ContentBlock[] = [];
        for (let item of data) {
            contentBlocks.push(ContentBlock.createOne(item));
        }
        return ContentBlock.sortByOrder(contentBlocks);
    }

    public static createOne(data: any): ContentBlock {
        let contentBlock = new ContentBlock();
        contentBlock.fill(data);
        return contentBlock;
    }

    public static sortByOrder(contentBlocks: ContentBlock[]) {
        return contentBlocks.sort((a, b) => {
            if (a.order < b.order) return -1;
            if (a.order > b.order) return 1;
            return 0;
        });
    }

    public fill(data: any) {
        this.id = data.id || null;
        this.content = data.content || null;
        this.location = data.location || null;
        this.order = data.order || null;
        this.title = data.title || null;
        this.entry = data.entry ? Entry.createOne(data.entry) : null;
    }

}



// WEBPACK FOOTER //
// ./src/models/content-block.ts